import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Show, useAuth } from "@clerk/react";
import { setTokenGetter, getMe } from "@/lib/api";

const MeContext = createContext(null);
export const useMe = () => useContext(MeContext);

const Session = ({ children }) => {
  const { getToken } = useAuth();
  const [me, setMe] = useState(null);
  const [failed, setFailed] = useState(false);
  const load = useCallback(() => {
    setFailed(false);
    setTokenGetter(getToken);
    getMe().then(setMe).catch(() => setFailed(true));
  }, [getToken]);
  useEffect(load, [load]);
  if (failed)
    return (
      <div data-testid="session-error" className="relative z-10 p-10 text-center">
        <p className="mb-4 text-zinc-300">Não foi possível carregar a sua conta.</p>
        <button data-testid="session-retry" onClick={load} className="tap h-12 px-6 bg-[#CCFF00] text-black font-semibold">Tentar novamente</button>
      </div>
    );
  if (!me) return null;
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
};

export const RequireAuth = ({ children }) => (
  <>
    <Show when="signed-in"><Session>{children}</Session></Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);
